import { connect } from "react-redux";
import * as actions from "./actions";

function mapStateToProps(state) {
  return { organisations: state.organisations };
}

function mapDispatchToProps(dispatch) {
  return {
    addCompany: (
      orgNo,
      name,
      address,
      postalCode,
      city,
      country,
      ownerPersonId,
    ) => {
      dispatch(
        actions.add_company(
          orgNo,
          name,
          address,
          postalCode,
          city,
          country,
          ownerPersonId,
        ),
      );
    },
    addOriginator: (data) => {
      dispatch(actions.add_originator(data));
    },
  };
}

export const organisationConnector = connect(
  mapStateToProps,
  mapDispatchToProps,
);
